<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'add_business_partner_dialog.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      <span>{{ 'add_business_partner_dialog.company_name' | translate }}</span>
      <input type="text" [(ngModel)]="businessPartnerName" />
    </label>
    <label>
      <span>{{ 'add_business_partner_dialog.name' | translate }}</span>
      <input type="text" [(ngModel)]="contactName" />
    </label>
    <label>
      <span>{{ 'add_business_partner_dialog.last_name' | translate }}</span>
      <input type="text" [(ngModel)]="contactLastName" />
    </label>
    <label>
      <span>{{ 'add_business_partner_dialog.contact_email' | translate }}</span>
      <input type="email" [(ngModel)]="contactEmail" />
    </label>
    <label>
      <span>{{ 'add_business_partner_dialog.contact_phone' | translate }}</span>
      <input type="tel" [(ngModel)]="contactPhone" />
    </label>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="submitting">{{ 'add_business_partner_dialog.cancel' | translate }}</button>
    <button class="button" type="button" (click)="onSubmit()" [disabled]="submitting">
      {{ (mode === 'edit' ? 'add_business_partner_dialog.save' : 'add_business_partner_dialog.submit') | translate }}
    </button>
  </div>
  
</div>


